/**
 * @exports HAS_NOTIFICATIONS_ENABLED
 */
export const HAS_NOTIFICATIONS_ENABLED = true

/**
 * @exports PENDING_AD_KEY
 */
export const PENDING_AD_KEY = 'pendingAdData'

/**
 * @exports PENDING_AD_ID_KEY
 */
export const PENDING_AD_ID_KEY = 'adId'

/**
 * @exports DEFAULT_UNREAD_MESSAGES
 */
export const DEFAULT_UNREAD_MESSAGES = 0
